import { render } from "./HeroiconsSolidPresentationChartBar.vue?vue&type=template&id=2f1c09ce"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPresentationChartBar.vue"]])

export default __exports__